import { requestFlat } from '../constants/requestFlat';
import { flatRequestColorsMap } from '../constants/stagesColorMaps';

const useFlatRequestsCount = (requests = []) => {
  if (!requests || !requests?.length) return [];

  const countRequestMap = new Map([
    [
      'sumNew',
      {
        value: 'Новая',
        color: flatRequestColorsMap.get(requestFlat.NEW_REQUEST),
        count: 0,
      },
    ],
    [
      'sumProgress',
      {
        value: 'В работе',
        color: flatRequestColorsMap.get(requestFlat.WORK_REQUEST),
        count: 0,
      },
    ],
    [
      'sumCompleted',
      {
        value: 'Выполнена',
        color: flatRequestColorsMap.get(requestFlat.COMPLETED_REQUEST),
        count: 0,
      },
    ],
    [
      'sumClosed',
      {
        value: 'Закрыта',
        color: flatRequestColorsMap.get(requestFlat.CLOSE_REQUEST),
        count: 0,
      },
    ],
  ]);

  requests.forEach((request) => {
    if (!!request.sumNew) {
      countRequestMap.set('sumNew', {
        ...countRequestMap.get('sumNew'),
        count: countRequestMap.get('sumNew').count + 1,
      });
      return;
    }

    if (!!request.sumProgress) {
      countRequestMap.set('sumProgress', {
        ...countRequestMap.get('sumProgress'),
        count: countRequestMap.get('sumProgress').count + 1,
      });
      return;
    }

    if (!!request.sumCompleted) {
      countRequestMap.set('sumCompleted', {
        ...countRequestMap.get('sumCompleted'),
        count: countRequestMap.get('sumCompleted').count + 1,
      });
      return;
    }

    if (!!request.sumClosed) {
      countRequestMap.set('sumClosed', {
        ...countRequestMap.get('sumClosed'),
        count: countRequestMap.get('sumClosed').count + 1,
      });
      return;
    }
  });

  return Array.from(countRequestMap.values());
};

export default useFlatRequestsCount;
